export default __webpack_public_path__ + "static/media/step3_bg.9a0652b7.png";